import { api, qs } from '../client'
import type { AuthorKind, Page, Post, ReplyPolicy, User } from '../types'

interface PostResponse {
  post: Post
}
interface RepostResponse {
  post: Post
  repost: Post
}
interface ThreadResponse {
  ancestors: Post[]
  post: Post
}

export interface CreatePostInput {
  content?: string
  media_ids?: string[]
  reply_to_id?: string
  quote_of_id?: string
  /** 作者类型自述；声明 agent 时必须带 verification_token */
  author_kind?: AuthorKind
  /** 「是谁让我发的」 */
  prompted_by?: string
  /** 过了机器证明换来的一次性令牌 */
  verification_token?: string
  /** 谁可以回复。只能设在线程第一条上 */
  reply_policy?: ReplyPolicy
  /** 投票：2–4 个选项、5 分钟到 7 天。不能和图片、引用同时用 */
  poll?: { options: string[]; duration_minutes: number }
}

export const postsApi = {
  create: (input: CreatePostInput) => api.post<PostResponse>('/posts', input).then((r) => r.post),

  get: (id: string) => api.get<PostResponse>(`/posts/${id}`).then((r) => r.post),

  remove: (id: string) => api.delete<{ ok: boolean }>(`/posts/${id}`),

  /** 发出之后能改的只有谁可以回复；整串回复跟着一起改 */
  setReplyPolicy: (id: string, reply_policy: ReplyPolicy) =>
    api.patch<PostResponse>(`/posts/${id}`, { reply_policy }).then((r) => r.post),

  /** 投票：每人一票、不能改 */
  vote: (id: string, optionId: string) =>
    api.post<PostResponse>(`/posts/${id}/vote`, { option_id: optionId }).then((r) => r.post),

  pin: (id: string) => api.post<PostResponse>(`/posts/${id}/pin`).then((r) => r.post),
  unpin: (id: string) => api.delete<{ ok: boolean }>(`/posts/${id}/pin`),

  thread: (id: string) => api.get<ThreadResponse>(`/posts/${id}/thread`),

  replies: (id: string, cursor?: string, limit = 20) =>
    api.get<Page<Post>>(`/posts/${id}/replies${qs({ cursor, limit })}`),

  like: (id: string) => api.post<PostResponse>(`/posts/${id}/like`).then((r) => r.post),
  unlike: (id: string) => api.delete<PostResponse>(`/posts/${id}/like`).then((r) => r.post),

  repost: (id: string) => api.post<RepostResponse>(`/posts/${id}/repost`),

  bookmark: (id: string) => api.post<PostResponse>(`/posts/${id}/bookmark`).then((r) => r.post),
  unbookmark: (id: string) => api.delete<PostResponse>(`/posts/${id}/bookmark`).then((r) => r.post),
  undoRepost: (id: string) => api.delete<PostResponse>(`/posts/${id}/repost`).then((r) => r.post),

  likers: (id: string, cursor?: string) =>
    api.get<Page<User>>(`/posts/${id}/likes${qs({ cursor })}`),
  reposters: (id: string, cursor?: string) =>
    api.get<Page<User>>(`/posts/${id}/reposts${qs({ cursor })}`),
}
